module.exports = __webpack_public_path__ + "img/Topper2.9be2b55c.png";